import UserInfo from "./UserInfo";
import SettingsLink from "./SettingsLink";
import LanguageChange from "./LanguageChange";
import LogoutOption from "./LogoutOption";
import Notification from "./Notification";

function HeaderSettings() {
  return (
    <div className="flex justify-center items-center gap-4">
      <UserInfo />
      <Notification />
      <SettingsLink />

      {/* <LanguageChange /> */}

      <LogoutOption />
    </div>
  );
}

export default HeaderSettings;
